import {Grid, Typography} from '@mui/material';

import {ButtonV2} from '@jobseeker/lotus/elements';
import {Image} from '@jobseeker/lotus/components/Image';
import {useSelector} from 'react-redux';
import {EPOCH} from '@constants';
import dayjs from 'dayjs';
import {useWrappedTheme} from '@jobseeker/lotus/hooks';
import {formQueryParams} from '@utils';
import {isCSR} from '@jobseeker/lotus/utils';
import {TrackEventUBA} from '@jobseeker/common-core/utils';

import type {AppState} from '@jobseeker/common-core/types';

const ParticipationBanner = () => {
  const theme = useWrappedTheme();
  const page = useSelector((state: AppState) => state.app.page);
  const {
    timelines: {
      registration: {endDate},
      config: {competitionName},
    },
  } = useSelector((state: AppState) => state.competition);
  const currentDate = dayjs();
  const registrationEnded = dayjs(endDate) < currentDate;
  const {competitionIdentity, testSlug} = useSelector(
    (state: AppState) => state.user?.profile
  );

  const registeredForCompetition = competitionIdentity && testSlug;

  let queryParams = '';
  if (isCSR()) {
    queryParams = formQueryParams('');
  }

  const handleRegisterClick = () => {
    TrackEventUBA('marketingPageClick', 'click', {
      pageName: 'EPOCH Landing',
      initiativeName: `EPOCH${new Date().getFullYear()}`,
      actionSrc: 'Register Now',
    });
  };

  return (
    <>
      {page === EPOCH && !registeredForCompetition && (
        <>
          <Grid
            container
            sx={{
              width: '100%',
              display: 'flex',
              flexWrap: 'wrap',
              backgroundColor: 'primary.main',
              borderRadius: 3,
              paddingTop: 3,
              paddingBottom: {xs: 3, md: 0},
            }}
          >
            <Grid
              item
              md={7}
              xs={12}
              sx={{
                background: {
                  xs: `url(https://static.iimjobs.com/epoch/static/assets/participantbannerMobile.webp) no-repeat center center`,
                  md: `url(https://static.iimjobs.com/epoch/static/assets/participationBanner.webp) no-repeat center center`,
                },
                position: 'relative',
                left: {xs: 0, md: 70, lg: 0},
                height: 300,
                top: {md: 0, xs: 30},
                backgroundSize: 'contain !important',
                '@media screen and (min-width: 800px && max-width: 1024px)': {
                  left: 24,
                  top: 34,
                },
              }}
            ></Grid>

            <Grid
              item
              md={5}
              xs={12}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: {xs: 'center', md: 'flex-start'},
                p: 3,
              }}
            >
              <Typography
                sx={{
                  fontSize: {
                    xs: theme.typography.pxToRem(24),
                    md: theme.typography.pxToRem(28),
                  },
                  color: '#fff',
                  fontWeight: 500,
                }}
              >
                Your Wait Ends!
              </Typography>
              <Typography
                sx={{
                  fontSize: {
                    xs: theme.typography.pxToRem(32),
                    md: theme.typography.pxToRem(48),
                  },
                  color: '#fff',
                  mb: 3,
                  fontWeight: 500,
                  lineHeight: 1.5,
                }}
              >
                Participate Now!
              </Typography>
              <ButtonV2
                type="submit"
                sx={{
                  width: '100%',
                  maxWidth: 220,
                  height: 70,
                  padding: 3,
                  // borderRadius: 3,
                  background: registrationEnded ? '#ed2048' : '#fff',
                  ':hover': {
                    backgroundColor: registrationEnded ? '#ed2048' : '#f0f0f0',
                  },
                  color: registrationEnded ? '#fff' : 'primary.main',
                }}
                href={
                  registrationEnded
                    ? 'javascript:void(0);'
                    : `/${competitionName}/register${
                        queryParams ? `?${queryParams}` : ''
                      }`
                }
                target="_self"
                variant="contained"
                size="large"
                onClick={registrationEnded ? undefined : handleRegisterClick}
              >
                {registrationEnded ? 'Registration is closed' : 'Register Now'}
                {!registrationEnded ? (
                  <Image
                    src={
                      'https://static.iimjobs.com/epoch/static/assets/greenArrow.svg'
                    }
                    alt={'Arrow'}
                    width={18}
                    height={22}
                    loading="eager"
                    style={{margin: '0 5px 0 10px'}}
                  />
                ) : (
                  ''
                )}
              </ButtonV2>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default ParticipationBanner;
